import { createAction, props } from '@ngrx/store';

import { TransactionDtoStoreModel } from '@domain/charger-sessions/charger-sessions.models';
import { VehicleDetailsResponseStoreModel, VehicleDetailsWebsocketMessageStoreModel } from '@domain/vehicle-details/vehicle-details.models';

import { MovableCardsContainerViewModel } from '@shared/components/movable-cards-container';

import { VehicleDetailsOverviewCard } from '../enums/vehicle-details-overview-card.enum';

export const loadVehicleDetails = createAction('[Vehicle details overview] load vehicle details');
export const loadVehicleDetailsSuccess = createAction(
  '[Vehicle details overview] load vehicle details success',
  props<{ vehicleDetails: VehicleDetailsResponseStoreModel }>()
);
export const loadVehicleDetailsFailure = createAction(
  '[Vehicle details overview] load vehicle details failure',
  props<{ error: string }>()
);

export const vehicleDetailsSocketMessageArrive = createAction(
  '[Vehicle details overview] vehicle details socket message arrive',
  props<{ message: VehicleDetailsWebsocketMessageStoreModel }>()
);

export const setCardsLayout = createAction(
  '[Vehicle details overview] set cards layout',
  props<{ layout: MovableCardsContainerViewModel<VehicleDetailsOverviewCard>; lgActive: boolean }>()
);

export const loadProperCardLayout = createAction(
  '[Vehicle details overview] load proper card layout',
  props<{ telemetryFeaturesEnabled: boolean }>()
);

export const clearVehicleDetailsOverviewData = createAction('[Vehicle details overview] clear vehicle details overview data');

export const loadRecentChargingSessions = createAction('[Vehicle details overview] load recent charging sessions');
export const loadRecentChargingSessionsSuccess = createAction(
  '[Vehicle details overview] load recent charging sessions success',
  props<{ sessions: TransactionDtoStoreModel[] }>()
);
export const loadRecentChargingSessionsFailure = createAction(
  '[Vehicle details overview] load recent charging sessions failure',
  props<{ error: string }>()
);
